export default "__VITE_ASSET__DTUCVMi$__"